// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"00bab57f","455":"409bf4c6","488":"37fb5523","977":"8c2b5dad"}[chunkId] + ".chunk.js";
};